"use strict";

const gridUnitFactor = '0.4rem';
const factor = parseFloat(gridUnitFactor);
const unit = gridUnitFactor.replace(/\d|\./g, '');
const gu = x => "".concat(x * factor).concat(unit);
module.exports = {
  gu
};